/**
 * Conversão de código de barras (44 dígitos) para linha digitável (47 dígitos).
 *
 * Layout FEBRABAN do código de barras, igual para qualquer banco:
 *   0-2   banco
 *   3     moeda
 *   4     DV geral
 *   5-8   fator de vencimento
 *   9-18  valor
 *   19-43 campo livre (25 dígitos)
 *
 * Linha digitável:
 *   campo 1 (10) = banco + moeda + campo livre 1-5   + DV
 *   campo 2 (11) = campo livre 6-15                  + DV
 *   campo 3 (11) = campo livre 16-25                 + DV
 *   campo 4 (1)  = DV geral
 *   campo 5 (14) = fator de vencimento + valor
 */

const formata = (campo1, campo2, campo3, campo4, campo5) =>
  [
    `${campo1.slice(0, 5)}.${campo1.slice(5)}`,
    `${campo2.slice(0, 5)}.${campo2.slice(5)}`,
    `${campo3.slice(0, 5)}.${campo3.slice(5)}`,
    campo4,
    campo5,
  ].join(" ");


const dvCampo = (campo) => {
  let soma = 0;
  let peso = 2;

  for (let i = campo.length - 1; i >= 0; i--) {
    let produto = Number(campo[i]) * peso;
    if (produto > 9) produto -= 9;

    soma += produto;
    peso = peso === 2 ? 1 : 2;
  }

  const resto = soma % 10;
  return String(resto === 0 ? 0 : 10 - resto);
};


const dvGeralValido = (digitos) => {
  const semDv = digitos.slice(0, 4) + digitos.slice(5);
  let soma = 0;
  let peso = 2;

  for (let i = semDv.length - 1; i >= 0; i--) {
    soma += Number(semDv[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }

  const dv = 11 - (soma % 11);

  return String(dv === 0 || dv === 10 || dv === 11 ? 1 : dv) === digitos[4];
};

/** Banco esperado nos boletos emitidos pela plataforma (756 = Sicoob). */
const BANCO_ESPERADO = "756";


export function montaLinhaDigitavel(valor) {
  const digitos = String(valor ?? "").replace(/\D/g, "");

  if (digitos.length === 47)
    return formata(
      digitos.slice(0, 10),
      digitos.slice(10, 21),
      digitos.slice(21, 32),
      digitos.slice(32, 33),
      digitos.slice(33, 47)
    );

  if (digitos.length !== 44) return null;

  if (!dvGeralValido(digitos)) {
    console.warn("Código de barras com DV geral inválido:", digitos);
    return null;
  }

  // não bloqueia: se um dia entrar outro emissor a conversão continua correta
  if (!digitos.startsWith(BANCO_ESPERADO))
    console.warn(`Boleto de banco inesperado: ${digitos.slice(0, 3)} (esperado ${BANCO_ESPERADO})`);

  const bancoMoeda = digitos.slice(0, 4);
  const dvGeral = digitos.slice(4, 5);
  const fatorValor = digitos.slice(5, 19);
  const campoLivre = digitos.slice(19, 44);

  const campo1 = bancoMoeda + campoLivre.slice(0, 5);
  const campo2 = campoLivre.slice(5, 15);
  const campo3 = campoLivre.slice(15, 25);

  return formata(
    campo1 + dvCampo(campo1),
    campo2 + dvCampo(campo2),
    campo3 + dvCampo(campo3),
    dvGeral,
    fatorValor
  );
}


export function extraiCodigoBarras(boletos) {
  const lista = Array.isArray(boletos) ? boletos : [boletos];

  for (const boleto of lista) {
    const candidato =
      boleto?.boleto_codigo_barras ?? boleto?.boleto_coleto_barras ?? boleto?.payment_method?.barcode ?? null;

    if (candidato) return candidato;
  }

  return null;
}